import Phaser from 'phaser';
import { AudioManager } from './utilities/AudioManager';
import { GameSettingsManager } from './utilities/GameSettingsManager';

export class AudioScene extends Phaser.Scene {
  protected audioManager: AudioManager = new AudioManager(true, true);
  protected gameSettingsManager: GameSettingsManager;

  constructor(config, gameIdentifier) {
    super(config);
    this.gameSettingsManager = new GameSettingsManager(gameIdentifier);
  }

  public getAudioManager() {
    return this.audioManager;
  }

  public getGameSettingsManager() {
    return this.gameSettingsManager;
  }
}